import { render, staticRenderFns } from "./PromotionPopup.vue?vue&type=template&id=05df062c&scoped=true"
import script from "./PromotionPopup.vue?vue&type=script&lang=js"
export * from "./PromotionPopup.vue?vue&type=script&lang=js"
import style0 from "./PromotionPopup.vue?vue&type=style&index=0&id=05df062c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05df062c",
  null
  
)

export default component.exports